/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungDto } from '../../models/buchung-dto';
import { StopDatafoxBuchungRequestDto } from '../../models/stop-datafox-buchung-request-dto';

export interface StopBuchung$Json$Params {
  
    /**
     * Buchungsinformationen
     */
    body?: StopDatafoxBuchungRequestDto
}

export function stopBuchung$Json(http: HttpClient, rootUrl: string, params?: StopBuchung$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<BuchungDto>> {
  const rb = new RequestBuilder(rootUrl, stopBuchung$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BuchungDto>;
    })
  );
}

stopBuchung$Json.PATH = '/v1/datafox/buchungen/stop';
